// --- Our Modules --------------------------------------------------------------------------------
import "./styles.css";
// --- Logic --------------------------------------------------------------------------------------
type Props = {
    label: string;
    /** Already formatted — "6.4 of 10 GB". The meter does not know what it is measuring. */
    value: string;
    percent: number;
    tone?: "normal" | "warn" | "bad";
};

/**
 * A labelled bar. Storage is the one number in this product that can actually stop a company working,
 * so it is drawn rather than printed: a figure says 4.8, a bar says *nearly full*.
 */
export default function Meter({ label, value, percent, tone = "normal" }: Props) {
    return (
        <div className="meter">
            <div className="meter__row">
                <span className="meter__label">{label}</span>
                <span className="meter__value">{value}</span>
            </div>
            <div className="meter__track">
                <div className="meter__fill" data-tone={tone} style={{ width: `${percent}%` }} />
            </div>
        </div>
    );
}
